wbApp.controller('LeadsTabsCrmNotesCtrl', ['$scope', '$modal', '$translate', 'leadSvc', 'notificationSvc',
function ($scope, $modal, $translate, leadSvc, notificationSvc) {

    $scope.leadNotes = [];
    var selectedLead = null;
    var fullLead = null;

    var isActive = false;
    var loaded = false;

    $scope.$on('leadSelectionChanged', function (e, newlySelectedLead) {
        if (newlySelectedLead) {
            if (isActive) {
                loadData(newlySelectedLead.id);
            } else {
                loaded = false;
            }
        }
        else {
            $scope.leadNotes = [];
            fullLead = null;
        }

        selectedLead = newlySelectedLead;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 3) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedLead) {
                    loadData(selectedLead.id);
                }
            }
        } else {
            isActive = false;
        }
    });

    function loadData(id) {
        $scope.leadNotes = [];
        leadSvc.getById(id).$promise.then(function (data) {
            fullLead = data;
            $scope.leadNotes = fullLead.notes;
            loaded = true;
        }, function (error) {
            fullLead = null;
            $scope.leadNotes = [];
            loaded = false;
        });
    }

    $scope.onRowAdd = function () {
        leadsNoteDetailPromise.$promise.then(function () {
            leadsNoteDetailPromise.$scope.leadId = selectedLead.id;
            leadsNoteDetailPromise.$scope.noteId = null;
            leadsNoteDetailPromise.$scope.onLeadSave = function (model) {
                $scope.$emit('leadChanged', { id: selectedLead.id });
            };
            leadsNoteDetailPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        leadsNoteDetailPromise.$promise.then(function () {
            leadsNoteDetailPromise.$scope.leadId = selectedLead.id;
            leadsNoteDetailPromise.$scope.noteId = data.id;
            leadsNoteDetailPromise.$scope.onLeadSave = function () {
                $scope.$emit('leadChanged', { id: selectedLead.id });
            };
            leadsNoteDetailPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        leadSvc.getById(fullLead.id).$promise.then(function (lead) {
            if (lead.status == 1) {
                notificationSvc.notifyError($translate.instant('TXT_ERROR_LEAD_ALREADY_CONVERTED'));
            }
            else {

                if (!!lead.notes && typeof data.id !== 'undefined' || data.id !== null) {
                    var idx = _.findIndex(lead.notes, { 'id': data.id });
                    if (idx != -1) {
                        lead.notes.splice(idx, 1);
                        leadSvc.update(lead).$promise.then(function () {
                            $scope.$emit('leadChanged', { id: selectedLead.id });
                        });
                    }
                }
            }
        });
    }

    $scope.leadNotesGridSettings = {
        name: 'leadNotes',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            {
                dataField: 'text', caption: $translate.instant('TXT_LBL_NOTE'), dataType: 'string'

            },
            { dataField: 'nextContactAtUtc', caption: $translate.instant('TXT_LBL_NEXT_CONTACT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            { dataField: 'updatedAtUtc', caption: $translate.instant('TXT_LBL_UPDATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px', sortOrder: 'desc' },
            { dataField: 'updatedByName', caption: $translate.instant('TXT_LBL_UPDATED_BY'), dataType: 'string', width: '160px' },
        ],
        shouldDisableAdd: function () { return !selectedLead || selectedLead.status == 1; },
        shouldDisableEdit: function () { return !selectedLead || selectedLead.status == 1; },
        shouldDisableDelete: function () { return !selectedLead || selectedLead.status == 1; },

    }

    var leadsNoteDetailPromise = $modal({
        templateUrl: 'leads/leads-detail-tabs/crm-notes-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
